import { PlusIcon } from '..';
import AGButton from '../../../components/Button';
import { RolesHandle } from '../../../components/RolesHandle';
import { Div } from '../commerce.styled';
import { ContactProps } from './Decription.Modal.props';
import { DesContent } from './Description.styled';

const DescriptionModal = ({ setShow, bodyContent, data }: ContactProps) => {

    return (
        <>
            {data?.description ?
                <DesContent className="description">
                    {data?.description}
                </DesContent>
                : (<Div className='btn-add-new'>
                    <RolesHandle
                        firmId={data?.fkFirmId!}
                        roles={["Admin", 'FirmCommerceManagement']}
                    >
                        <AGButton
                            type={'Link'}
                            icon={<PlusIcon />}
                            onClick={() => {
                                setShow()
                            }}>
                            {bodyContent}
                        </AGButton>
                    </RolesHandle>
                </Div>)
            }
        </>
    )
}

export default DescriptionModal;